<div class="custom-error">
  <h1>{{ errorMessage }}</h1>
</div>
